module.exports = __webpack_public_path__ + "static/media/earthquake.57d60287.png";